import RotaryDiagram from "../../../../docs/_images/hw_ff_ky_040.png";
import RotarySchematics from "../../../../docs/_images/hw_ff_ky_040_schem.png";
import * as React from 'react';
export default {
  RotaryDiagram,
  RotarySchematics,
  React
};